/* eslint-disable react/prop-types */
import { useContext, useEffect, useRef, useState } from 'react';
import LeadGenerationContext from '../../context/LeadGenerationContext';

function LoginPageInternal(props) {
  const elRef = useRef(null);

  const { wcData, initiateUiResponse } = useContext(LeadGenerationContext);
  console.log({ wcData });
  const { productName, language, productType, otpToken } = wcData.salesData || {};

  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    // Keep your candidate order
    const candidates = [
      '/wc-ExpressFlowInitializer.js',
      '/dist/wc-ExpressFlowInitializer.js',
      '/static/js/wc-ExpressFlowInitializer.js',
      'dist/wc-ExpressFlowInitializer.js',
    ];

    function handleScriptLoad(resolve) {
      return () => resolve();
    }
    function handleScriptError(reject) {
      return () => reject(new Error('Failed to load script'));
    }
    function injectScriptSrc(url) {
      return new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = url;
        s.defer = true;
        s.onload = handleScriptLoad(resolve);
        s.onerror = handleScriptError(reject);
        document.head.appendChild(s);
      });
    }

    function fetchCandidate(url) {
      return fetch(url, { cache: 'no-store' })
        .then((res) => ({ url, res }))
        .catch((err) => ({ url, err }));
    }

    function getCandidateText(item) {
      if (item.res?.ok) {
        return item.res.text().then((text) => ({
          url: item.url,
          text,
        }));
      }

      return Promise.resolve({
        url: item.url,
        text: null,
      });
    }
    function findValidBundle(texts) {
      for (const url of candidates) {
        const t = texts.find((x) => x.url === url);
        if (t?.text) {
          const preview = t.text.trim().slice(0, 20);
          if (preview.startsWith('<')) {
            console.warn('Login bundle at', url, 'looks like HTML. Preview:', preview);
          } else {
            return url;
          }
        }
      }

      return null;
    }

    async function tryLoad() {
      try {
        const settled = await Promise.all(candidates.map(fetchCandidate));

        const texts = await Promise.all(settled.map(getCandidateText));

        const foundUrl = findValidBundle(texts);

        if (foundUrl) {
          // IMPORTANT: load by URL (no blob)
          await injectScriptSrc(foundUrl);
          if (!cancelled) {
            try {
              await customElements.whenDefined('sales-express-wc');
              setLoaded(true);
            } catch (e) {
              setError(e);
            }
          }
          return;
        }

        if (!cancelled) {
          setError(new Error('Could not find a valid sales-express-wc bundle in candidates'));
        }
      } catch (err) {
        if (!cancelled) {
          setError(err);
        }
      }
    }

    tryLoad();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (loaded && elRef.current && typeof elRef.current.renderWebComponent === 'function') {
      try {
        elRef.current.renderWebComponent({
          custIdToken: wcData.otpToken,
          devicePlatform: '',
          lang: wcData.language,
          source: 'OMB',
          wcFlow: true,
          salesData: {
            location: 'PR',
            productName: wcData.productName,
            productType: wcData.productType,
            offers: false,
          },
          env: initiateUiResponse.REACT_APP_ENVIRONMENT,
          analyticsInitialized: true,
        });
      } catch (e) {
        console.error('renderWebComponent call failed', e);
      }
    }
  }, [loaded, otpToken, productName, productType, language, wcData]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {error && (
        <div style={{ padding: 16 }}>
          <strong>Webcomponent load error:</strong>
          <div>{String(error)}</div>
        </div>
      )}
      <div style={{ width: '100%', height: '100%' }}>
        <sales-express-wc
          ref={elRef}
          productName={wcData.productName}
          productType={wcData.productType}
        />
      </div>
    </div>
  );
}

export default LoginPageInternal;
